<div class="flex gap-2" *ngIf="meeting && meeting.location">
  <img class="h-20" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/svg/location.svg" alt="Location of Interview">
  <span *ngIf="meeting.interviewType == InterviewType.INPERSON">
    <span class="font-medium text-4 text-dark leading-24">Face to Face: </span>
    <span class="text-4 text-dark leading-24">{{formatAddress(meeting.location.address, meeting.location.postCode)}}</span>
  </span>
  <span *ngIf="meeting.interviewType == InterviewType.TELEPHONE">
    <span class="font-medium text-4 text-dark leading-24">Phone Call: </span>
    <ng-container *ngIf="PhoneCallAltText else phoneCallDefaultText">
      <span class="text-4 text-dark leading-24">
        Phone Call Interview
      </span>
    </ng-container>
    <ng-template #phoneCallDefaultText>
      <span class="text-4 text-dark leading-24"
        *ngIf="meeting.location.callPreference == 'call_us'">
        Please contact {{meeting.location.contactName}} on {{meeting.location.phone}} at the scheduled time.
      </span>
      <span class="text-4 text-dark leading-24"
        *ngIf="meeting.location.callPreference == 'call_them'">
        Please expect a call from {{dashboardInfo?.companyName}} on the number provided ({{meeting.location.phone}}) at the scheduled time.
      </span>
    </ng-template>
  </span>
  <span *ngIf="meeting.interviewType == InterviewType.REMOTE">
    <span class="font-medium text-4 text-dark leading-24">Remote: </span>
    <span class="text-4 text-dark leading-24">{{meeting.locationType}}</span>
  </span>
</div>
